import { api, auth } from '@/f1/service';
import codes from '@/f1/codes';
import { Switch as cSwitch } from '@coreui/vue';
import Language from './language';
// import agent from '../../agent/service'

//restful api
// import { wsfinder as wf } from '@/f1/service/api';

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  components: { cSwitch, Language },
  computed: {  }, // i18n 메세지 변환용.
  data : () => {
    return {
      apply_alive : 0,
      modal_save : false,
      is_test : false,
      auth,
      codes,
      confirm: false,
      add: false,
      lock: true,
      model : {},
      status : {},
      pattern_test : []
    }
  },
  methods: {
    is_valid() {
      if(!(this.model.type || '')) {  this.$toastr.e(`${i18n_data._i18n_error.type_check[this.i18n]}`); return false; }
      if(!(this.model.ext || '')) {  this.$toastr.e(`${i18n_data._i18n_error.ext_check[this.i18n]}`); return false; }
      if(!(this.model.category || '')) {  this.$toastr.e(`${i18n_data._i18n_error.category_check[this.i18n]}`); return false; }
      if(!(this.model.code || '')) {  this.$toastr.e(`${i18n_data._i18n_error.code_check[this.i18n]}`); return false; }
      if(this.model.is_alive == undefined) {  this.$toastr.e(`${i18n_data._i18n_error.is_alive_check[this.i18n]}`); return false; }

      // vaildate RegExp (Task #1921)
      if(this.model.type == '1') { // 1 = Regex
        let pattern = '/' + this.model.code + '/';
        let flag = '';
        let re = (function(o, p, f) {
          try { return new RegExp(p, f); }
          catch(e) { return o.$toastr.e(e.message); }
        })(this, pattern, flag);

        if(re instanceof RegExp) {
          this.$toastr.s(`${i18n_data._i18n_success.expression_check[this.i18n]}` + pattern);
        } else {
          this.$toastr.e(`${i18n_data._i18n_error.regex_valid[this.i18n]}`);
          return false
        }
      }
      return true
    },
    async test() {
      if(!this.is_valid()) { return }
      try {

        // 강제 미사용 적용
        this.model.is_alive = false
        // 모달 닫기
        this.modal_save = false

        let rs = await api.wsfinder.WSFinder_Call('pattern', 'test', this.model)
        //let rs = await wf.pattern.test(this.modal)
        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}`) }
        console.log(rs.body)
        if(rs.body.alive && rs.body.alive > 0) {
          // 점검 요청하였으며 곧 안내됩니다
          this.$toastr.s(`${i18n_data._i18n_success.test[this.i18n]}`);
          this.is_test = true
          this.apply_alive = rs.body.alive
          this.apply_request = rs.body.request
          this.$parent.$emit('refresh')
        } else {
          // rs.body.count
          return this.$toastr.e(`${i18n_toastr._i18n_error.count[this.i18n]}`)
        }

        // 전송 완료한 에이전트 목록을 줘야 함, 여기서 에이전트 미리 영향도 테스트는 강제 해야 한다
      } catch(e) { this.$toastr.e(e.data ? `${i18n_toastr._i18n_error.count[this.i18n]}` :  e.data.message ? e.data.message : e.statusText) ; }
    },
    cancel: function() {
      if(this.add) { return this.list() }
      this.lock = true
    },
    list: function() { this.$router.push({ name: 'wsfinder_pattern'}); this.$parent.$emit('refresh') },
    async save() {
      // 모달 닫기
      this.modal_save = false

      if(!this.is_valid()) { return }

      try {
        // this.model.is_alive = true
        let rs = await api.wsfinder.WSFinder_Call('pattern', this.model.id ? 'update' : 'insert', this.model)

        // let check_id = this.model.id ? `${await wf.pattern.update(this.modal)}` : `${await wf.pattern.insert(this.modal)}`
        // let rs = check_id;

        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}`) }

        this.$toastr.s(`${i18n_data._i18n_success.saved[this.i18n]}`);
        this.$parent.$emit('refresh');
        this.list();

        // return;
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.save_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) ; }
    },
    async response_handler(m) {

      if(m.cmd != 'pattern.test' && m.cmd != 'status') { return }

      let pl = m.body;

      console.log(m.cmd, pl, m)
      // switch (m.cmd) {
      //   case 'status':
      //     this.status[m.agent_id] = Object.assign({}, this.status[m.agent_id], JSON.parse(pl))
      //     break;
      //     case 'pattern.test':
      //     this.pattern_test.push(pl)
      //     break;

      //   default:
      //     break;
      // }
    },
    // list() { this.$router.push({ name: 'wsfinder_pattern'}); },
    edit() { this.lock = false },
    async remove() {
      try{
        await api.wsfinder.WSFinder_Call('pattern', 'delete', { id : this.model.id})
        //await wf.pattern.delete({ id : this.model.id})
        this.$emit('refresh'); this.$toastr.s(`${i18n_data._i18n_success.removed[this.i18n]}`); this.list();
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.remove_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) , this.list() }
    },
    async get(id = this.$route.params.id) {
      console.log('pattern.detail.vue', 'load item', id);
      this.lock = true
      if(id == 'add') { this.lock = false; this.add = true; return }
      try {
        let rs = await api.wsfinder.WSFinder_Call('pattern', 'detail', { id : id})
        //let rs = await wf.pattern.detail({ id : id})

        this.model = Object.assign({}, this.model, rs.body)
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) , this.list() }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(from.path) } },
  created: function() {   console.log('pattern.detail.vue', 'created'); },
  destroyed: function() {
    console.log('pattern.detail.vue', 'destroyed');
    // signalr.subscribe('wsfinder', this.response_handler);
  },
  mounted: function() {
    console.log('pattern.detail.vue', 'mounted');
    this.get(this.$route.params.id);
    // signalr.subscribe('wsfinder', this.response_handler);
  },
}
